/**
 * スポット詳細の初期化
 */
export function initSpotDetail($) {
  if ($('body.single-spots').length === 0) return;

  // サムネイル数をチェック
  const $subSlide = $('.s-spots-detail__slide--sub');
  const thumbnailCount = $subSlide.find('.c-slide__item').length;

  // サムネイルが1枚の場合はサブスライドを非表示
  if (thumbnailCount <= 1) {
    $subSlide.hide();

    // メインスライドのみ初期化（サブスライドと連動しない）
    $('.s-spots-detail__slide--main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      centerMode: true,
      centerPadding: '0',
      variableWidth: true,
      infinite: false,
      arrows: true, // スマホ時は表示
      dots: false,
      responsive: [
        {
          breakpoint: 768, // md未満
          settings: {
            arrows: true,
          },
        },
        {
          breakpoint: 9999, // md以上
          settings: {
            arrows: false,
          },
        },
      ],
    });
    return;
  }

  // サムネイルが複数ある場合は通常の初期化
  // メインスライド
  $('.s-spots-detail__slide--main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '#sub-slide',
    focusOnSelect: false,
    centerMode: true,
    centerPadding: '0',
    variableWidth: true,
    infinite: true,
    arrows: true, // スマホ時は表示
    dots: false,
    responsive: [
      {
        breakpoint: 768, // md未満
        settings: {
          arrows: true,
        },
      },
      {
        breakpoint: 9999, // md以上
        settings: {
          arrows: false,
        },
      },
    ],
  });

  // サブスライド
  $subSlide.slick({
    slidesToShow: 5,
    asNavFor: '#main-slide',
    infinite: true,
    arrows: false, // スマホ時は非表示
    dots: false,
    focusOnSelect: true,
    centerMode: true,
    centerPadding: '0',
    responsive: [
      {
        breakpoint: 768, // md未満
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 9999, // md以上
        settings: {
          arrows: true,
        },
      },
    ],
  });

  $subSlide.each(function() {
    if ($(this).find('.c-slide__item').length <= 5) {
      $(this)
        .find('.slick-track')
        .addClass('no-scroll-center');
    }
  });
}
